export const getLineHeightFromFontSize = (value: number): number => {
    return value + value * 0.2;
};
